import { render, staticRenderFns } from "./newAnaliticsForns.vue?vue&type=template&id=4efa68e5"
import script from "./newAnaliticsForns.vue?vue&type=script&lang=js"
export * from "./newAnaliticsForns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports